// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"230":"a32e5f37","239":"95a1d137","898":"0d1416ee"}[chunkId] + ".js";
};